const show = (inView) => {
    return inView ? 'show' : 'hidden'
}


//export modules
module.exports = {
    show
}